(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-cro-header"] && !Shopify.designMode) return;
  try {
    
if(!window.maCroNav){window.maCroNav=true;document.addEventListener('click',event=>{document.querySelectorAll('.cro-header details[open]:not(.ma4-mobile-group)').forEach(el=>{if(!el.contains(event.target))el.removeAttribute('open')})});document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.cro-header details[open]:not(.ma4-mobile-group)').forEach(el=>{el.removeAttribute('open');el.querySelector('summary').focus()})}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-v2-cart-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const page = document.querySelector('.at-cart-page[data-section-id]');
  if (!page) return;
  let edited = false;
  page.addEventListener('input', () => { edited = true; });
  async function reconcile() {
    if (edited || page.contains(document.activeElement)) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', page.dataset.sectionId);
      url.searchParams.set('_ma_sync', Date.now());
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updated = doc.querySelector('.at-cart-page[data-section-id]');
      if (updated && !edited && !page.contains(document.activeElement) && updated.dataset.cartSignature !== page.dataset.cartSignature) {
        page.innerHTML = updated.innerHTML;
        page.dataset.cartSignature = updated.dataset.cartSignature;
      }
    } catch (error) { /* Native cart form remains available on network failure. */ }
  }
  [800, 2500, 6000].forEach(delay => setTimeout(reconcile, delay));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-v2-finder"] && !Shopify.designMode) return;
  try {
    
if(!window.maAtTabs){window.maAtTabs=true;document.addEventListener('click',e=>{const b=e.target.closest('[data-at-tab]');if(!b)return;const root=b.closest('[data-at-tabs]');root.querySelectorAll('[data-at-tab]').forEach(x=>{x.setAttribute('aria-selected',x===b?'true':'false');x.tabIndex=x===b?0:-1});root.querySelectorAll('[data-at-panel]').forEach(x=>x.hidden=x.dataset.atPanel!==b.dataset.atTab)});document.addEventListener('keydown',e=>{if(!e.target.matches('[data-at-tab]')||!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const buttons=[...e.target.closest('[role=tablist]').querySelectorAll('button')];let i=buttons.indexOf(e.target);i=e.key==='Home'?0:e.key==='End'?buttons.length-1:(i+(e.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;buttons[i].click();buttons[i].focus()})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-v2-trio"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ma-trio'))customElements.define('ma-trio',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.products=JSON.parse(this.querySelector('script').textContent);this.slots=[...this.querySelectorAll('.at-trio-slot')];this.money=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency});this.slots.forEach((s,i)=>{const p=s.querySelector('[data-trio-product]');if(p.options.length)p.selectedIndex=Math.min(i,p.options.length-1);p.addEventListener('change',()=>this.fill(s));s.querySelector('[data-trio-variant]').addEventListener('change',()=>this.total());this.fill(s)});this.querySelector('[data-trio-add]').addEventListener('click',()=>this.add())}fill(s){const p=this.products.find(x=>String(x.id)===s.querySelector('[data-trio-product]').value);if(!p)return;const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.loading='lazy';img.width=500;img.height=500;s.querySelector('.at-trio-preview').replaceChildren(img);s.querySelector('[data-trio-variant]').replaceChildren(...p.variants.map(v=>{const o=document.createElement('option');o.value=v.id;o.textContent=v.title;return o}));this.total()}selection(){return this.slots.map(s=>{const p=this.products.find(x=>String(x.id)===s.querySelector('[data-trio-product]').value);return p?.variants.find(v=>String(v.id)===s.querySelector('[data-trio-variant]').value)}).filter(Boolean)}total(){const list=this.selection();this.slots.forEach((s,i)=>s.querySelector('.at-trio-unit').textContent=list[i]?this.money.format(list[i].price/100):'');const sum=list.reduce((a,v)=>a+v.price,0);this.querySelector('[data-trio-original]').textContent=this.money.format(sum/100);this.querySelector('[data-trio-total]').textContent=this.money.format((sum-(list.length===3?Math.min(...list.map(v=>v.price)):0))/100);this.querySelector('[data-trio-add]').disabled=list.length!==3}async add(){const button=this.querySelector('[data-trio-add]'),label=button.textContent,status=this.querySelector('.at-trio-status');button.disabled=true;button.textContent=this.dataset.loading;status.textContent='';try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:this.selection().map(v=>({id:v.id,quantity:1})),sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})});const data=await response.json();if(!response.ok)throw Error(data.description||this.dataset.error);const drawer=document.querySelector('cart-drawer');if(drawer&&data.sections?.['cart-drawer']){drawer.classList.remove('is-empty');drawer.renderContents(data)}else location.assign(root+'cart')}catch(e){status.textContent=e.message||this.dataset.error}finally{button.textContent=label;button.disabled=false}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-v3-guide"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ma-format-guide'))customElements.define('ma-format-guide',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const tabs=[...this.querySelectorAll('[role=tab]')],panels=[...this.querySelectorAll('[role=tabpanel]')];const choose=i=>{tabs.forEach((b,j)=>{b.setAttribute('aria-selected',j===i);b.tabIndex=j===i?0:-1;panels[j].hidden=j!==i})};tabs.forEach((b,i)=>{b.addEventListener('click',()=>choose(i));b.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight'||e.key==='ArrowDown')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();choose(n);tabs[n].focus()})})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-v3-product-return"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ma-product-return'))customElements.define('ma-product-return',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const native=document.querySelector('product-form.main-product-form .product-form__submit'),source=document.querySelector('.product__info-container [id^="price-"]'),target=document.querySelector('.at-photo-choice')||document.querySelector('variant-selects')||document.querySelector('.product__info-container');if(!native||!target)return;this.watch=new IntersectionObserver(entries=>{this.classList.toggle('is-visible',entries[0].boundingClientRect.bottom<0)},{threshold:0});this.watch.observe(native);const price=()=>{if(!source)return;const box=source.querySelector('.price')||source;const node=box.classList.contains('price--on-sale')?box.querySelector('.price__sale .price-item--sale'):box.querySelector('.price__regular .price-item--regular');if(node)this.querySelector('[data-return-price]').textContent=node.textContent.trim()};price();if(source){this.mutation=new MutationObserver(price);this.mutation.observe(source,{childList:true,subtree:true,characterData:true})}this.querySelector('button').addEventListener('click',()=>{target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});const focus=target.querySelector('input:checked')||target.querySelector('button,input');focus?.focus({preventScroll:true})})}disconnectedCallback(){this.watch?.disconnect();this.mutation?.disconnect()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-v3-trio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ma-trio-studio')) customElements.define('ma-trio-studio', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.selected = [null, null, null];
    this.cache = new Map();
    this.productCache = new Map();
    this.slots = [...this.querySelectorAll('.ma3-trio-slot')];
    this.money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
    this.dialog = this.querySelector('dialog');
    this.grid = this.querySelector('.ma3-catalog-grid');
    this.format = this.querySelector('[data-catalog-format]');
    this.catalogStatus = this.querySelector('.ma4-catalog-status');
    this.button = this.querySelector('[data-trio-add]');
    this.buttonLabel = this.button.textContent;
    this.page = 1;
    this.pages = 1;
    this.slots.forEach((slot, index) => {
      slot.querySelector('.ma3-slot-pick').addEventListener('click', () => {
        this.active = index;
        this.dialog.showModal();
        this.load(this.page);
      });
      slot.querySelector('.ma3-slot-remove').addEventListener('click', () => {
        this.selected[index] = null;
        this.paint(index);
        this.update();
        slot.querySelector('.ma3-slot-pick').focus();
      });
    });
    this.format.addEventListener('change', () => this.load(1));
    this.querySelector('[data-catalog-prev]').addEventListener('click', () => this.load(this.page - 1));
    this.querySelector('[data-catalog-next]').addEventListener('click', () => this.load(this.page + 1));
    this.dialog.querySelector('.ma3-close').addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
    this.dialog.addEventListener('close', () => this.slots[this.active]?.querySelector('.ma3-slot-pick').focus());
    this.button.addEventListener('click', () => this.add());
    this.update();
  }
  async load(page) {
    this.request = (this.request || 0) + 1;
    const request = this.request;
    const url = new URL(this.format.value, location.origin);
    url.searchParams.set('view', 'ma-trio');
    url.searchParams.set('page', page);
    const key = url.href;
    this.catalogStatus.textContent = this.dataset.catalogLoading;
    this.grid.setAttribute('aria-busy', 'true');
    this.querySelectorAll('.ma4-catalog-pages button').forEach(button => button.disabled = true);
    try {
      let data = this.cache.get(key);
      if (!data) {
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw Error(this.dataset.catalogError);
        data = JSON.parse(await response.text());
        this.cache.set(key, data);
      }
      if (request !== this.request) return;
      this.page = data.page;
      this.pages = data.pages;
      this.grid.replaceChildren(...data.products.map(product => this.card(product)));
      this.catalogStatus.textContent = data.products.length ? '' : this.dataset.catalogEmpty;
      this.querySelector('[data-catalog-page]').textContent = this.dataset.catalogPage.replace('[page]', this.page).replace('[pages]', this.pages);
      this.querySelector('[data-catalog-prev]').disabled = this.page <= 1;
      this.querySelector('[data-catalog-next]').disabled = this.page >= this.pages;
    } catch (error) {
      if (request === this.request) { this.grid.replaceChildren(); this.catalogStatus.textContent = this.dataset.catalogError; }
    } finally { if (request === this.request) this.grid.setAttribute('aria-busy', 'false'); }
  }
  card(product) {
    const card = document.createElement(product.personalized ? 'a' : 'button');
    card.className = 'ma3-catalog-card' + (product.personalized ? ' ma4-catalog-card-link' : '');
    const image = document.createElement('img');
    image.src = product.image; image.alt = product.title; image.loading = 'lazy'; image.width = 500; image.height = 500;
    const text = document.createElement('span'), title = document.createElement('strong'), price = document.createElement('small');
    title.textContent = product.title;
    price.textContent = product.personalized ? this.dataset.personalize : this.dataset.from + ' ' + this.money.format(Math.round(product.price * 2 / 3) / 100);
    text.append(title, price); card.append(image, text);
    if (product.personalized) card.href = product.url;
    else {
      card.type = 'button';
      card.setAttribute('aria-label', this.dataset.pick + ' ' + product.title);
      card.addEventListener('click', () => this.choose(product, card));
    }
    return card;
  }
  async choose(summary, card) {
    if (this.choosing) return;
    this.choosing = true; card.disabled = true;
    this.catalogStatus.textContent = this.dataset.catalogLoading;
    const index = this.active;
    try {
      let product = this.productCache.get(summary.id);
      if (!product) {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'products/' + encodeURIComponent(summary.handle) + '.js');
        if (!response.ok) throw Error(this.dataset.catalogError);
        const data = await response.json();
        product = { ...summary, variants: data.variants.filter(variant => variant.available), options: data.options };
        if (!product.variants.length) throw Error(this.dataset.catalogEmpty);
        this.productCache.set(summary.id, product);
      }
      if (!this.dialog.open || this.active !== index) return;
      this.selected[index] = { product, variant: product.variants[0] };
      this.paint(index); this.update(); this.dialog.close();
    } catch (error) { this.catalogStatus.textContent = error.message || this.dataset.catalogError; }
    finally { this.choosing = false; card.disabled = false; }
  }
  label(value) {
    return value.replace('Toile roulée', this.dataset.unframed).replace('Toile sur châssis', this.dataset.framed).replace('Standard (24 couleurs)', '24 '+this.dataset.colours).replace('Haute Résolution (36 couleurs)', '36 '+this.dataset.colours).replace('Ultra Haute Résolution (48 couleurs)', '48 '+this.dataset.colours).replace(/ CM/g, ' cm');
  }
  paint(index) {
    const slot = this.slots[index], selected = this.selected[index], preview = slot.querySelector('.ma3-slot-preview'), name = slot.querySelector('[data-slot-name]'), picker = slot.querySelector('.ma3-slot-pick');
    slot.querySelector('.ma3-slot-detail').hidden = !selected;
    if (!selected) {
      const span = document.createElement('span'), plus = document.createElement('b');
      plus.textContent = '+'; plus.setAttribute('aria-hidden', 'true'); span.append(plus, document.createTextNode(this.dataset.pick)); preview.replaceChildren(span);
      name.textContent = this.dataset.pick + ' ' + (index + 1); picker.setAttribute('aria-label', name.textContent); return;
    }
    const image = document.createElement('img');
    image.src = selected.product.image; image.alt = selected.product.title; image.width = 500; image.height = 500; preview.replaceChildren(image);
    name.textContent = selected.product.title; picker.setAttribute('aria-label', this.dataset.change + ' ' + (index + 1) + ' : ' + selected.product.title);
    const controls = selected.product.options.map((option, position) => {
      const wrap = document.createElement('div'), label = document.createElement('p'), choices = document.createElement('div');
      label.textContent = option.name || option;
      choices.className = 'ma16-home-options'; choices.setAttribute('role','group'); choices.setAttribute('aria-label',label.textContent);
      const values = [...new Set(selected.product.variants.map(variant => variant.options[position]))];
      values.forEach(value => {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = this.label(value);
        button.setAttribute('aria-pressed', String(value === selected.variant.options[position]));
        button.addEventListener('click', () => {
          const preferred = [...selected.variant.options]; preferred[position] = value;
          selected.variant = selected.product.variants.find(variant => variant.options.every((v, i) => v === preferred[i])) || selected.product.variants.find(variant => variant.options[position] === value);
          this.paint(index); this.update();
          this.slots[index].querySelectorAll('.ma16-home-options')[position]?.querySelector('[aria-pressed="true"]')?.focus();
        }); choices.append(button);
      });
      wrap.append(label, choices); return wrap;
    });
    slot.querySelector('[data-slot-options]').replaceChildren(...controls);
  }
  update() {
    const selected = this.selected.filter(Boolean), sum = selected.reduce((amount, slot) => amount + slot.variant.price, 0), saving = selected.length === 3 ? Math.min(...selected.map(slot => slot.variant.price)) : 0;
    this.slots.forEach((slot, index) => { const selected = this.selected[index]; slot.querySelector('[data-slot-price]').textContent = selected ? this.money.format(selected.variant.price / 100) : ''; });
    this.querySelector('[data-trio-progress]').textContent = this.dataset.progress.replace('[count]', selected.length);
    this.querySelector('[data-trio-original]').textContent = this.money.format(sum / 100);
    this.querySelector('[data-trio-saving]').textContent = saving ? '− ' + this.money.format(saving / 100) : this.money.format(0);
    this.querySelector('[data-trio-total]').textContent = selected.length ? this.money.format((sum - saving) / 100) : this.dataset.empty;
    this.button.disabled = selected.length !== 3 || this.pending;
  }
  async add() {
    if (this.pending || this.selected.filter(Boolean).length !== 3) return;
    this.pending = true; this.button.disabled = true; this.button.textContent = this.dataset.loading;
    const status = this.querySelector('.ma3-trio-status'); status.textContent = '';
    try {
      const root = window.Shopify?.routes?.root || '/', grouped = new Map();
      this.selected.forEach(slot => grouped.set(slot.variant.id, (grouped.get(slot.variant.id) || 0) + 1));
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [...grouped].map(([id, quantity]) => ({ id, quantity })), sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname }) });
      const data = await response.json();
      if (!response.ok) throw Error(data.description || this.dataset.error);
      status.textContent = this.dataset.added;
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections?.['cart-drawer']) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
      else location.assign(root + 'cart');
    } catch (error) { status.textContent = error.message || this.dataset.error; }
    finally { this.pending = false; this.button.textContent = this.buttonLabel; this.update(); }
  }
});

  } catch(e) { console.error(e); }
})();
})();
